
import LinkResolver from './LinkResolver.vue'
export default {
  name: 'MemberServicesProfiles',
  components: { LinkResolver },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
